// extracted by mini-css-extract-plugin
export default {"privacyContainer":"PrivacyPolicy_privacyContainer__larpE"};